import React from 'react'
import { RegistrationListItem } from './RegistrationListItem'
import { AddValidatorFunc } from '../../hooks/validators'
import { useAppSelector } from '../../hooks'
import { Card, Row, Table } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { stages } from '../../routes'
import { filterExistingRegistrations, filterNewRegistrations } from '../../store/registrations/selectors'

const RegistrationList = (props: {
  isEditable: boolean
  addValidator?: AddValidatorFunc
}) => {
  const { isEditable, addValidator } = props
  const { list: registrations } = useAppSelector((state) => state.registrations)
  const isSingleRegistration = registrations.length === 1

  const navigate = useNavigate()
  const location = useLocation()
  const parentStage = stages.find((stage) =>
    location.pathname.includes(stage.path)
  )

  const cards = filterNewRegistrations(registrations)
    .slice()
    .sort((a, b) => a.priority - b.priority)
    .map((registration) => (
      <RegistrationListItem
        key={`registration-${registration.event_id}`}
        registration={registration}
        editable={isEditable}
        addValidator={addValidator}
        isSingle={isSingleRegistration}
      />
    ))

  const existing_registrations = filterExistingRegistrations(registrations)
    .slice()
    .sort((a, b) => a.priority - b.priority)

  const existing_registrations_list = existing_registrations.map(
    (registration) => (
      <tr
        key={`registration-${registration.event_id}`}
      >
        <td>{registration.event_name}</td>
        <td>{registration.event?.duration_summary || "Vergangene Veranstaltung"}</td>
        <td>{registration.priority + 1}</td>
      </tr>
    )
  )

  return (
    <>
      <Row>{cards}</Row>
      {existing_registrations.length > 0 && (
        <>
          <hr />
          <Card>
            <Card.Header className="text-center">
              <h2 aria-level={1}>Bestehende Anmeldungen</h2>
            </Card.Header>
            <Card.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>Titel</th>
                    <th>Zeitraum</th>
                    <th className="feature-priority">Priorität</th>
                  </tr>
                </thead>
                <tbody>{existing_registrations_list}</tbody>
              </Table>
            </Card.Body>
          </Card>
        </>
      )}
    </>
  )
}

export default RegistrationList
